import { ScreenLayoutProvider } from './ScreenLayoutProvider';
import { Sidebar } from './Sidebar';
import { useScreenSidebar } from './useScreenSidebar';
import { Main, Section } from './styled';
/**
 * Layout component that provides a screen with an optional contextual sidebar, header and main content area.
 * Takes a optional id prop to make the sidebar state unique.
 */
export function Root(props) {
    const { topbar, content, sidebar, id } = props;
    const { layoutRef } = useScreenSidebar(id);
    return (<ScreenLayoutProvider id={id}>
      <Section>
        {topbar}

        <Main ref={layoutRef}>
          {content}
          {sidebar && <Sidebar>{sidebar}</Sidebar>}
        </Main>
      </Section>
    </ScreenLayoutProvider>);
}
